module.exports = __webpack_public_path__ + "static/media/home-changing-2.3bb58569.jpg";